import React from 'react';

import {
  DetailsSidebar,
  DetailsSidebarProvider,
  DetailsSidebarTrigger,
  HStack,
  Icon,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@eluve/components';

import { ChatWithEluveGpt } from './ChatWithEluveGpt';

interface EluveGptTriggerProps {
  tenantId: string;
  baseUrl: string;
}

export const EluveGptTrigger: React.FC<EluveGptTriggerProps> = ({
  tenantId,
  baseUrl,
}) => {
  return (
    <DetailsSidebarProvider overlayOnly>
      <DetailsSidebarTrigger>
        <div className="fixed bottom-6 right-6 z-50">
          <Tooltip>
            <TooltipTrigger asChild>
              <HStack
                className="size-12 cursor-pointer rounded-full bg-bg-insights-subtle p-2"
                justify="center"
                align="center"
              >
                <Icon
                  name="Lightbulb"
                  size="sm"
                  className="text-text-insights"
                />
              </HStack>
            </TooltipTrigger>
            <TooltipContent side="left">Eluve Insights</TooltipContent>
          </Tooltip>
        </div>
      </DetailsSidebarTrigger>

      <DetailsSidebar size="lg" title="Eluve Insights" allowFullscreen>
        <ChatWithEluveGpt tenantId={tenantId} baseUrl={baseUrl} />
      </DetailsSidebar>
    </DetailsSidebarProvider>
  );
};
